import stylex from '@stylexjs/stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';

export const styles = stylex.create({
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 32px',
    fontFamily: fonts.din2014Regular,
  },
  modalTitle: {
    color: colors.primaryText,
    fontSize: typography['fontSizeHeading-4'],
    lineHeight: typography['lineHeightBody-1'],
    margin: 0,
  },
  closeButton: {
    cursor: 'pointer',
    fill: colors.tertiaryIcon,
  },
  modalBody: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'flex-start',
    height: '556px',
    width: '100%',
    overflowX: 'hidden',
    ':not(#__unused__) [data-testid="label-txt"]': {
      height: 'auto',
    },
  },
  modalSwitcherRow: {
    padding: '0 32px',
    flexShrink: 0,
    paddingBottom: '24px',
    width: '100%',
  },
  modalSectionsScrollWrapper: {
    flex: 1,
    minHeight: 0,
    width: '100%',
    padding: '0 20px 0 32px',
    boxSizing: 'border-box',
    borderRadius: anatomy.borderRadiusS,
    overflow: 'hidden',
  },
  modalSections: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: anatomy['space-12'],
    width: '100%',
  },
  modalFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: anatomy['space-10'],
    padding: '16px 32px',
    fontFamily: fonts.din2014Regular,
  },
});
